// ISS-032 family (3 Nov 2026): a SELL OPTIONS trade is NAMED after its scanner pair ("SELL NATURALGAS 250CE/300PE"),
// while each pair picks its strikes fresh at entry (e.g. 250CE / 315PE). A book row whose executed contract is not one
// of the name's strikes says so, so the name is never read as the position.
export function nameStrikes(name) {
  return [...String(name || "").matchAll(/(\d+(?:\.\d+)?)(CE|PE)\b/g)].map((m) => `${m[1]}${m[2]}`);
}

export function scannerNameDiffers(name, symbols) {
  const ks = nameStrikes(name);
  const syms = (symbols || []).filter(Boolean).map(String);
  if (!ks.length || !syms.length) return false;
  return syms.some((s) => /(CE|PE)$/.test(s) && !ks.some((k) => s.endsWith(k)));
}
